// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"ProductList_headerContainer__1W-TM"};